/* eslint react/prop-types: off */
/* eslint no-unused-vars: off */

/***
 * Options for Single Value Widget.
 */
import {
  WIDGET_COLOURS,
  WIDGET_COMPARISION_OPERATORS,
  WIDGET_FORMAT_OPTIONS
} from 'helpers/widgetHelper';
import React, { useEffect, useState } from 'react';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';

function ConditionalStylingRow({
  index,
  formatOption,
  deleteFormatOption,
  setOperator,
  setValue,
  setColour
}) {
  return (
    <>
      <InputGroup className="mb-3">
        <Form.Select
          value={formatOption.operator}
          onChange={e => {
            setOperator(index, e.target.value);
          }}
        >
          {WIDGET_COMPARISION_OPERATORS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label} ({option.value})
            </option>
          ))}
        </Form.Select>
        <FormControl
          type="number"
          defaultValue={0}
          value={formatOption.value}
          onChange={e => {
            setValue(index, e.target.value);
            // formatOptions[index].value = e.target.value;
            // onChange(formatOptions);
          }}
        />
        <Form.Select
          value={formatOption.colour}
          className={`bg-${formatOption.colour}`}
          onChange={e => {
            setColour(index, e.target.value);
          }}
        >
          {WIDGET_COLOURS.map(option => (
            <option
              key={option.value}
              value={option.value}
              className={`bg-${option.value}`}
            >
              {option.label}
            </option>
          ))}
        </Form.Select>
        <Button
          className="bg-danger"
          onClick={e => {
            deleteFormatOption(index);
          }}
        >
          X
        </Button>
      </InputGroup>
    </>
  );
}

function ConditionalStyling({ state, onChange }) {
  const [_, setRerender] = useState(0); // Dummy state
  const [formatOptions, setFormatOptions] = useState([]);
  //console.log('Conditional formatting render!!!');

  useEffect(() => {
    if (state.conditionalStyling && state.conditionalStyling.length > 0) {
      setFormatOptions(state.conditionalStyling);
    }
  }, []);

  const updateState = () => {
    onChange(Object.assign({}, state, { conditionalStyling: formatOptions }));
  };

  const handleFormatOptionChange = data => {
    setFormatOptions(data);
    // setRerender(prev => prev + 1); // Trigger a state change
    updateState();
  };

  const deleteFormatOption = index => {
    console.log('DELETING -->', index);
    setFormatOptions(formatOptions.splice(index, 1));
    console.log(formatOptions);
    // setRerender(prev => prev + 1);
    updateState();
  };

  const setOperator = (index, operator) => {
    let o = formatOptions;
    o[index].operator = operator;
    // setRerender(prev => prev + 1);
    updateState();
  };

  const setValue = (index, value) => {
    let o = formatOptions;
    o[index].value = value;
    // setRerender(prev => prev + 1);
    updateState();
  };

  const setColour = (index, colour) => {
    let o = formatOptions;
    o[index].colour = colour;
    // setRerender(prev => prev + 1);
    updateState();
  };

  return (
    <>
      <Form.Label>Conditional Styling</Form.Label>
      {formatOptions.map((option, index) => (
        <ConditionalStylingRow
          key={index}
          index={index}
          formatOption={option}
          onChange={handleFormatOptionChange}
          deleteFormatOption={deleteFormatOption}
          setOperator={setOperator}
          setValue={setValue}
          setColour={setColour}
        ></ConditionalStylingRow>
      ))}
      <Button
        onClick={e => {
          let options = formatOptions;
          options.push({ operator: '=', value: 10, colour: 'success' });
          setFormatOptions(options);
          setRerender(prev => prev + 1); // Trigger a state change
          updateState();
        }}
      >
        Add rule
      </Button>
    </>
  );
}

export default function SingleValueWigetOptions({ state, onChange }) {
  // const [test, setTest] = useState('');
  // console.log('PROPS.STATE===', props.state);
  // if (!props.state.test) {
  //   props.state.test = '';
  // }

  if (!state.format) {
    onChange(
      Object.assign({}, state, { format: WIDGET_FORMAT_OPTIONS[0].value })
    );
  }

  return (
    <>
      <Form.Label>Format</Form.Label>
      <Form.Select
        value={state.format}
        onChange={e =>
          onChange(Object.assign({}, state, { format: e.target.value }))
        }
      >
        {WIDGET_FORMAT_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <hr></hr>
      <ConditionalStyling
        state={state}
        onChange={onChange}
      ></ConditionalStyling>
    </>
  );
}
